import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useSettingsService } from '../../../../apis/settings/useSettingsService';
import { ComplianceListApiResponse } from '../../../../apis/settings/settings.Interfaces';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getComplianceListKey = 'get-compliance-list';

export const useComplianceListHook = (
  params: TPaginationParams,
  options?: Omit<
    UseQueryOptions<ComplianceListApiResponse, TQueryError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<ComplianceListApiResponse, TQueryError> => {
  const { getComplianceList } = useSettingsService();

  return useQuery<ComplianceListApiResponse, TQueryError>({
    queryKey: [getComplianceListKey, params],
    queryFn: () => getComplianceList(params),
    enabled: true,
    ...options,
  });
};
